<template>
  <button
    type="button"
    class="atom-button-fullscreen"
    :style="`--background-color: ${backgroundColor}`"
    @click="emit('on-click')"
  >
    <IonIcon
      icon-name="fullscreen"
      class="atom-button-fullscreen__icon"
      :icon-color="iconColor"
    />
  </button>
</template>

<script setup>
defineProps({
    iconColor: {
        type: String,
        default: 'var(--c-white)',
    },

    backgroundColor: {
        type: String,
        default: 'var(--c-primary)',
    },
});

const emit = defineEmits(['on-click']);
</script>

<style lang="scss" scoped>
.atom-button-fullscreen__icon {
    @include fluid-simple('width', 6px, 16px);

    transition: transform 0.2s ease-in-out;
}
.atom-button-fullscreen {
    @include fluid-simple('width', 24px, 69px);
    @include fluid-simple('height', 24px, 69px);
    display: flex;

    overflow: hidden;
    align-items: center;
    justify-content: center;
    border-radius: var(--b-radius--full);
    background: var(--background-color);

    @include hover {
        .atom-button-fullscreen__icon {
            transform: scale(1.1);
        }
    }
}

</style>
